module.exports = "/_next/static/images/bbcae2de6bb50fd6eb1b2e16393ffd2a-openAppQrCode.jpg.webp";